import { render, staticRenderFns } from "./LoginCliente.vue?vue&type=template&id=ede481c0&scoped=true&"
import script from "./LoginCliente.vue?vue&type=script&lang=js&"
export * from "./LoginCliente.vue?vue&type=script&lang=js&"
import style0 from "./LoginCliente.vue?vue&type=style&index=0&id=ede481c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede481c0",
  null
  
)

export default component.exports